module.exports = __webpack_public_path__ + "img/Pet Stairs.8416b0ad.jpg";